<!-- Only outlet is here -->
<router-outlet></router-outlet>
